import './faq.css'
import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TitleSection from '../TitleSection/TitleSection';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const FaqItem = ({ item, index }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
    });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ duration: 1, delay: index * 0.2 }}
            className="col-12"
        >
            <Accordion className='box-faq'>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    {item.title}
                </AccordionSummary>
                <AccordionDetails className='desfaq'>
                    {item.des}
                    {item.des2}
                </AccordionDetails>
            </Accordion>
        </motion.div>
    );
};

function Faq() {
    const DeatelisSection = [
        {
            id: 1,
            title: "ماهي تكويب ؟",
            des: "تكويب هي مؤسسة تقنية سعودية متخصصة في تقديم خدمات تصميم وإدارة مواقع الويب. بفريق من الخبراء السعوديين، تركز تكويب على إبداع حلول رقمية مبتكرة تناسب احتياجات العملاء وتساعدهم في تحقيق أهدافهم الرقمية بكفاءة وفعالية. سواء كنت تبحث عن تصميم موقع جديد، أو تحسين موقعك الحالي، أو إدارة المحتوى بشكل احترافي، تكويب تضمن لك الحصول على خدمة متميزة تعكس هويتك وتحقق تطلعاتك.",
        },
        {
            id: 2,
            title: "ماهي الخدمات التي تقدمها تكويب ؟",
            des: "تكويب تقدم مجموعة متنوعة من الخدمات التقنية المتخصصة لتلبية احتياجاتك الرقمية. تشمل هذه الخدمات تصميم المواقع الإلكترونية، حيث يتم إنشاء وتصميم مواقع ويب مبتكرة وجذابة. يتم تطوير صفحات هبوط فعّالة لتحسين معدلات التحويل. يُنشئ الفريق مدونات متميزة تدعم نشر المحتوى والتفاعل مع الجمهور، كما يتم تصميم مواقع إخبارية تلبي احتياجات نشر الأخبار والتحديثات.",
            des2: "في مجال التجارة الإلكترونية، تطور تكويب متاجر إلكترونية متكاملة لتسهيل عمليات البيع عبر الإنترنت. توفر تكويب خدمات إدارة محتوى المواقع الإلكترونية من خلال تحديث وصيانة المحتوى لضمان تجربة مستخدم ممتازة. يتم متابعة وإدارة الأداء العام للموقع والحفاظ على تشغيله بسلاسة، بالإضافة إلى تقديم خدمات الصيانة والتحديثات الفنية للمواقع. تكويب تقدم أيضًا خدمات شراء الاستضافة وإدارتها، حيث تؤمن استضافة موثوقة وتدير مواردها بكفاءة. تتضمن الخدمات أيضًا تسجيل النطاقات وربطها بالاستضافة لضمان تشغيل الموقع بأفضل صورة. 🌟🚀💻"

        },
        {
            id: 3,
            title: "كم أسعار تصميم وبرمجة صفحات الهبوط ؟",
            des: "تكلفة تصميم وبرمجة صفحات الهبوط تبدأ من 50 ريال، ولكن السعر يمكن أن يختلف بشكل كبير بناءً على عدة عوامل. يشمل ذلك مستوى التعقيد في التصميم، الميزات المطلوبة، واحتياجات العميل المحددة. كل مشروع يتم تقييمه بشكل فردي لضمان توفير حلول مخصصة تلبي متطلبات العميل بأفضل صورة ممكنة.",

        },
        {
            id: 4,
            title: "هل يوجد لديكم ضمان على الخدمات ؟",
            des: "الضمان لدينا يشمل عمل الموقع بشكل مستمر ودون انقطاع لمدة غير محدودة. كما نوفر ضمانًا لصيانة الموقع وحل المشاكل التقنية وفقًا للاتفاق المتفق عليه مع العميل، حيث تبدأ فترة الضمان من سنتين لضمان الصيانة والتعديلات المطلوبة. نحن نلتزم بتقديم أفضل خدمات الصيانة لضمان أن يكون موقعك دائمًا في أفضل حالاته، مما يتيح لك التركيز على تحقيق أهدافك الرقمية بكل ثقة. 🌟💻✨",

        },
        {
            id: 5,
            title: "هل يجب أن أوفر المحتوى ؟",
            des: "نعم، يجب أن توفر المحتوى سواء كان نصيًا، صورًا، أو فيديو. المحتوى هو جوهر الموقع، حيث يعتمد نجاح الموقع بشكل كبير على جودة وشمولية المحتوى المقدم. بدون محتوى ملائم، لن يكون للموقع تأثير بصري وجمالي مهما كان تصميمه رائعًا. المحتوى الجيد يعزز من تجربة المستخدم ويجذب الزوار ويشجعهم على البقاء والتفاعل مع الموقع. لذا، من الضروري توفير محتوى عالي الجودة لضمان أن يعكس الموقع هويتك ورسالتك بشكل صحيح وفعّال. 🌐📸✍️",
        },
        {
            id: 6,
            title: "ماهي خدمة إدارة المحتوى ؟",
            des: "خدمة إدارة المحتوى تركز على الحفاظ على تحديث ودقة محتوى الموقع الإلكتروني. تتضمن هذه الخدمة عدة جوانب، منها إضافة وتحديث النصوص، الصور، والفيديوهات، بالإضافة إلى تنظيم وتنسيق المحتوى لضمان تقديم تجربة مستخدم مثالية. يُساعد مديرو المحتوى في ضمان أن تكون المعلومات المقدمة على الموقع ملائمة وجذابة، مما يعزز من تجربة الزوار ويجذبهم للتفاعل مع المحتوى.",
        },
        {
            id: 7,
            title: "هل تؤثر الصور على تفاعل الزوار في الموقع ؟",
            des: "نعم، الصور تؤثر بشكل كبير على تفاعل الزوار في الموقع الإلكتروني. الصور الجذابة والمرتبطة بالمحتوى تساعد في جذب انتباه الزوار وتجعل تجربة التصفح أكثر متعة وجاذبية. استخدام الصور بشكل فعال يمكن أن يساهم في تحسين تجربة المستخدم من خلال توضيح الأفكار المعقدة وتوفير استراحة بصرية بين النصوص الطويلة.",
        },
        {
            id: 8,
            title: "هل يمكن أن أستغني عن صفحة الهبوط إذا كان لدي صفحات على منصات التواصل ؟",
            des: "بينما يمكن أن تلعب صفحات منصات التواصل الاجتماعي دورًا هامًا في التفاعل مع جمهورك وبناء علاقات معهم، إلا أن صفحات الهبوط توفر تجربة مركزة ومخصصة لتحقيق أهداف معينة. صفحات الهبوط تُصمم بعناية لتحقيق معدلات تحويل عالية من خلال توجيه الزوار نحو اتخاذ إجراء محدد مثل الاشتراك في خدمة، التسجيل في ندوة، أو شراء منتج. على منصات التواصل الاجتماعي، قد يكون من الصعب توجيه الزوار إلى إجراء معين بسبب التشتت الناتج عن المحتوى المتنوع والضوضاء الرقمية. بالإضافة إلى ذلك، صفحات الهبوط توفر لك مرونة أكبر في تصميم وتجربة المستخدم، مما يتيح لك تقديم معلومات محددة بطريقة منظمة وجذابة. لذا، رغم أهمية صفحات التواصل الاجتماعي، إلا أن الاستغناء عن صفحة الهبوط قد يقلل من فعالية حملاتك التسويقية في تحقيق أهدافها. من الأفضل الجمع بين الاثنين لتحقيق توازن واستفادة قصوى من الاستراتيجيات التسويقية المختلفة. 🌟📱🌐"
        },
    ];

    return (
        <div className='faq' id='faqid'>
            <div className="container">
                <TitleSection title="أسئلة العملاء" />
                <div className="row marginbox">
                    {DeatelisSection.map((item, index) => (
                        <FaqItem key={index} item={item} index={index} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Faq;
